import { render, staticRenderFns } from "./add_reserve_project.vue?vue&type=template&id=e575453c"
import script from "./add_reserve_project.vue?vue&type=script&lang=js"
export * from "./add_reserve_project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports